import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  LEGAL_CONTACT_EMAIL,
  LEGAL_SITE_NAME,
  LEGAL_URLS,
} from '../../config/legal';
import { CONTACT_WHATSAPP_DISPLAY } from '../../config/contact';
import { LegalPageShell } from './LegalPageShell';

export function DataDeletionPage() {
  useEffect(() => {
    document.title = `Eliminación de datos | ${LEGAL_SITE_NAME}`;
  }, []);

  return (
    <LegalPageShell title="Eliminación de datos">
      <p>
        En {LEGAL_SITE_NAME} respetamos tu derecho a solicitar la eliminación de tus datos
        personales. Esta página explica cómo hacerlo, conforme a nuestra{' '}
        <Link to={LEGAL_URLS.privacy}>Política de privacidad</Link> y a los requisitos de las
        plataformas con las que integramos el servicio (incluida Meta / WhatsApp Business).
      </p>

      <h2>1. Quién puede solicitar la eliminación</h2>
      <p>Puedes solicitar la eliminación si:</p>
      <ul>
        <li>Tienes una cuenta registrada en {LEGAL_SITE_NAME}.</li>
        <li>Nos has contactado por chat web, formulario o WhatsApp y quieres borrar esos datos.</li>
        <li>Eres titular de datos tratados en el marco de una integración con nuestra aplicación.</li>
      </ul>

      <h2>2. Cómo solicitar la eliminación</h2>
      <p>Envía un correo electrónico a:</p>
      <p>
        <a href={`mailto:${LEGAL_CONTACT_EMAIL}?subject=Solicitud%20de%20eliminaci%C3%B3n%20de%20datos`}>
          {LEGAL_CONTACT_EMAIL}
        </a>
      </p>
      <p>Incluye en el asunto: <strong>Solicitud de eliminación de datos</strong>.</p>
      <p>Indica, según corresponda:</p>
      <ul>
        <li>Tu nombre y apellidos.</li>
        <li>Correo electrónico asociado a tu cuenta de {LEGAL_SITE_NAME}.</li>
        <li>
          Si contactaste por WhatsApp, el número de teléfono desde el que escribiste (
          {CONTACT_WHATSAPP_DISPLAY}).
        </li>
        <li>Breve descripción de los datos que deseas eliminar.</li>
      </ul>
      <p>
        También puedes usar el <Link to="/contacto">formulario de contacto</Link> seleccionando
        una solicitud relacionada con privacidad o eliminación de datos.
      </p>

      <h2>3. Plazo de respuesta</h2>
      <p>
        Confirmaremos la recepción de tu solicitud y responderemos en un plazo máximo de{' '}
        <strong>30 días</strong>, salvo complejidad excepcional, en cuyo caso te informaremos de
        la ampliación conforme al RGPD.
      </p>

      <h2>4. Qué datos eliminamos</h2>
      <p>Según tu solicitud y la base legal aplicable, podemos eliminar o anonimizar:</p>
      <ul>
        <li>Datos de cuenta (nombre, email, preferencias).</li>
        <li>Historial de tickets de soporte, chat web y conversaciones de WhatsApp.</li>
        <li>Datos de contacto proporcionados en formularios.</li>
      </ul>

      <h2>5. Datos que podemos conservar</h2>
      <p>
        Es posible que debamos conservar determinados datos durante los plazos legalmente exigidos
        (por ejemplo, facturación, contabilidad o defensa de reclamaciones), en cuyo caso los
        bloquearemos y limitaremos su tratamiento a esas finalidades.
      </p>

      <h2>6. Eliminación de cuenta de cliente</h2>
      <p>
        Si deseas cerrar tu cuenta de {LEGAL_SITE_NAME}, indícalo expresamente en la solicitud.
        Cancelaremos la suscripción activa según el ciclo de facturación y procederemos a la
        eliminación o bloqueo de los datos asociados, salvo obligación legal de conservación.
      </p>

      <h2>7. Datos en Meta / WhatsApp</h2>
      <p>
        Los mensajes intercambiados por WhatsApp Business se procesan también en la infraestructura
        de Meta. Tras atender tu solicitud, eliminaremos los datos que obren en nuestros sistemas.
        Para ejercer derechos adicionales respecto a Meta, puedes consultar la política de
        privacidad de Meta en{' '}
        <a href="https://www.facebook.com/privacy/policy/" rel="noopener noreferrer" target="_blank">
          facebook.com/privacy/policy
        </a>
        .
      </p>

      <h2>8. Contacto</h2>
      <p>
        Para cualquier duda sobre privacidad o eliminación de datos:{' '}
        <a href={`mailto:${LEGAL_CONTACT_EMAIL}`}>{LEGAL_CONTACT_EMAIL}</a>.
      </p>
    </LegalPageShell>
  );
}
